import { Product } from "@stripe/firestore-stripe-payments";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


type InitialState = {
    products: Product[];
}

const initialState: InitialState = {
    products: [],
}

export const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        setProducts: (state, action: PayloadAction<Product[]>) => {
            state.products = action.payload;
        },

        addProduct: (state, action: PayloadAction<Product>) => {
            state.products.push(action.payload);
        }

    }
});

export const { setProducts, addProduct } = productSlice.actions;

export default productSlice.reducer;